import { render, staticRenderFns } from "./CustomerVisitLogsExtends.vue?vue&type=template&id=c2e16dc0"
import script from "./CustomerVisitLogsExtends.vue?vue&type=script&lang=js"
export * from "./CustomerVisitLogsExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports